const pick = (arr, slug) => arr[[...slug].reduce((a, ch) => a + ch.charCodeAt(0), 0) % arr.length];

export const SERVICE_PAGES = [
  {
    slug: "ouverture-de-porte",
    serviceId: "ouverture-porte",
    name: "Ouverture de porte",
    fromPrice: "100",
    title: (c) => `Ouverture de porte ${c.name} (${c.postal}) — Serrurier 24h/24 dès 100 €`,
    description: (c, x) =>
      `Porte claquée ou clés perdues à ${c.name} ? Ouverture de porte sans casse 24h/24 par un artisan serrurier local. Arrivée en ${x.time}, prix annoncé avant : dès 100 €.`,
    intro: (c, x) =>
      pick(
        [
          `Vous êtes bloqué dehors à <strong>${c.name}</strong> ? Porte claquée, clés oubliées à l'intérieur ou clé cassée dans la serrure : un serrurier de Mon Serrurier Breton part de Mont-Dol et arrive chez vous en <strong>${x.time}</strong>, de jour comme de nuit.`,
          `Besoin d'une <strong>ouverture de porte à ${c.name}</strong> ? Nous intervenons 24h/24 et 7j/7 depuis notre atelier de Mont-Dol, à environ ${x.dist} km. Le prix vous est annoncé au téléphone avant de partir, et nous ouvrons sans casse dans la grande majorité des cas.`,
          `Une porte qui se referme derrière vous, et les clés restées dedans : c'est l'appel que nous recevons le plus souvent à <strong>${c.name} (${c.postal})</strong>. Notre artisan arrive en ${x.time} et ouvre votre porte proprement, sans abîmer la serrure.`,
        ],
        c.slug,
      ),
    sections: (c, x) => [
      {
        h: `Porte claquée ou fermée à clé à ${c.name}`,
        p: `Une <strong>porte claquée</strong> (simplement tirée, sans tour de clé) s'ouvre en général en quelques minutes grâce à une technique d'ouverture fine : radio, crochetage ou by-pass. Une <strong>porte fermée à clé</strong> demande plus de travail, mais nous privilégions toujours la méthode qui préserve votre cylindre. Le remplacement de la serrure n'est proposé que s'il est vraiment nécessaire.`,
      },
      {
        h: "Ouverture sans casse : notre méthode",
        p: `Nous sommes équipés pour ouvrir les serrures standards, multipoints et les portes blindées des grandes marques (Picard, Vachette, Bricard, Fichet, Héraclès). À ${c.name}, nous intervenons aussi bien sur les portes de maison, d'appartement, de garage que sur les portes de locaux professionnels.`,
      },
      {
        h: `Prix d'une ouverture de porte à ${c.name}`,
        p: `Nos tarifs sont publics et identiques à ${c.name} et dans toutes nos communes : <strong>100 € pour une porte claquée en journée</strong>, 130 € pour une porte fermée à clé. Le déplacement et une éventuelle majoration de nuit ou de week-end sont annoncés avant l'intervention. Vous recevez une facture détaillée, utile pour votre assurance.`,
      },
    ],
    prices: [
      ["Porte claquée (jour)", "100 €"],
      ["Porte fermée à clé (jour)", "130 €"],
      ["Porte blindée claquée", "150 €"],
      ["Porte blindée fermée à clé", "250 €"],
    ],
    faq: (c, x) => [
      {
        q: `Combien coûte une ouverture de porte à ${c.name} ?`,
        a: `100 € pour une porte claquée en journée, 130 € si elle est fermée à clé, 150 à 250 € pour une porte blindée. Le prix est annoncé au téléphone avant notre départ.`,
      },
      {
        q: `En combien de temps arrivez-vous à ${c.name} ?`,
        a: `${c.name} est à environ ${x.dist} km de notre base de Mont-Dol : comptez ${x.time} selon l'heure et la circulation.`,
      },
      {
        q: "Allez-vous casser ma serrure ?",
        a: "Non dans la grande majorité des cas : nous utilisons des techniques d'ouverture fine. Si un remplacement est indispensable, nous vous l'expliquons et vous donnons le prix avant de toucher à quoi que ce soit.",
      },
    ],
  },
  {
    slug: "changement-de-serrure",
    serviceId: "changement-serrure",
    name: "Changement de serrure",
    fromPrice: "90",
    title: (c) => `Changement de serrure ${c.name} (${c.postal}) — Cylindre dès 90 € | Serrurier`,
    description: (c, x) =>
      `Changement de serrure ou de cylindre à ${c.name} : perte de clés, déménagement, cambriolage. Artisan serrurier local, cylindres A2P, pose rapide, devis gratuit. Dès 90 €.`,
    intro: (c, x) =>
      pick(
        [
          `Clés perdues, déménagement, séparation ou tentative d'effraction : à <strong>${c.name}</strong>, nous remplaçons votre serrure ou votre cylindre le jour même, avec du matériel de marque et un prix annoncé à l'avance.`,
          `Vous venez d'emménager à <strong>${c.name}</strong> et vous ne savez pas qui possède un double de vos clés ? Le <strong>changement de cylindre</strong> est la solution la plus simple et la moins chère pour retrouver une maison vraiment sûre.`,
          `Serrure qui force, clé qui tourne mal ou cylindre trop facile à forcer : à <strong>${c.name} (${c.postal})</strong>, notre artisan vient avec les principaux modèles en stock dans son camion et change votre serrure en une seule visite.`,
        ],
        c.slug,
      ),
    sections: (c) => [
      {
        h: "Cylindre ou serrure complète ?",
        p: `Dans la plupart des cas, il suffit de changer le <strong>cylindre</strong> (la partie où l'on met la clé) : c'est rapide et économique. Si le mécanisme de la serrure est usé ou si vous voulez plus de sécurité, nous posons une <strong>serrure multipoints</strong> qui verrouille la porte en plusieurs endroits.`,
      },
      {
        h: `Des marques reconnues, posées à ${c.name}`,
        p: `Nous posons des cylindres et serrures Picard, Vachette, Bricard, Héraclès et Assa Abloy, y compris des modèles <strong>certifiés A2P</strong> exigés par certaines assurances. Vous repartez avec un jeu de clés neuves et, si vous le souhaitez, une carte de propriété pour faire des doubles en toute sécurité.`,
      },
      {
        h: "Après un cambriolage",
        p: `Si votre serrure a été forcée à ${c.name}, nous intervenons en urgence pour sécuriser la porte le soir même, puis remplacer durablement la serrure. La facture détaillée vous permet d'être remboursé par votre assurance habitation.`,
      },
    ],
    prices: [
      ["Cylindre standard (3 clés)", "90 à 150 €"],
      ["Cylindre de sécurité (3 clés)", "140 à 260 €"],
      ["Serrure monopoint", "50 à 280 €"],
      ["Serrure multipoints", "280 à 650 €"],
    ],
    faq: (c, x) => [
      {
        q: `Combien coûte un changement de cylindre à ${c.name} ?`,
        a: "Entre 90 et 150 € pour un cylindre standard avec 3 clés, entre 140 et 260 € pour un cylindre de sécurité. Le déplacement est inclus dans le devis annoncé au téléphone.",
      },
      {
        q: "Pouvez-vous changer la serrure le jour même ?",
        a: `Oui, dans la plupart des cas : nous avons les modèles courants dans le camion. ${c.name} est à environ ${x.dist} km de Mont-Dol, comptez ${x.time} pour notre arrivée.`,
      },
      {
        q: "Faut-il changer la serrure après une perte de clés ?",
        a: "C'est recommandé si les clés peuvent être reliées à votre adresse (sac, papiers, porte-clés avec nom). Un simple changement de cylindre suffit généralement.",
      },
    ],
  },
  {
    slug: "blindage-de-porte",
    serviceId: "blindage-porte",
    name: "Blindage de porte",
    fromPrice: "350",
    title: (c) => `Blindage de porte ${c.name} (${c.postal}) — Porte anti-effraction | Serrurier local`,
    description: (c) =>
      `Blindage de porte à ${c.name} : plaque de blindage, serrure multipoints, cornière anti-pince, cylindre A2P. Conseil gratuit et devis clair par un artisan serrurier local.`,
    intro: (c) =>
      pick(
        [
          `Vous voulez rendre votre porte d'entrée plus solide à <strong>${c.name}</strong> sans la remplacer ? Le <strong>blindage de porte</strong> renforce votre porte actuelle et la rend beaucoup plus difficile à forcer.`,
          `À <strong>${c.name}</strong>, beaucoup de cambriolages passent par la porte d'entrée. Un blindage bien posé, une serrure multipoints et un cylindre de qualité suffisent souvent à décourager les voleurs.`,
          `Résidence principale ou maison souvent vide : à <strong>${c.name} (${c.postal})</strong>, nous vous conseillons gratuitement sur le bon niveau de protection, puis nous posons un blindage adapté à votre porte et à votre budget.`,
        ],
        c.slug,
      ),
    sections: (c) => [
      {
        h: "Ce que comprend un blindage",
        p: `Un blindage de porte, c'est une <strong>plaque d'acier</strong> fixée côté intérieur, une <strong>serrure multipoints</strong> qui verrouille la porte en 3 à 7 points, des <strong>cornières anti-pince</strong> pour empêcher de glisser un pied-de-biche et un <strong>cylindre de sécurité</strong> résistant au crochetage et à l'arrachage.`,
      },
      {
        h: `Particulièrement utile à ${c.name}`,
        p: `Les maisons et résidences secondaires qui restent inoccupées plusieurs semaines sont les plus exposées. Nous vous proposons aussi des éléments simples à poser : poignée blindée, protège-cylindre, verrou supplémentaire.`,
      },
      {
        h: "Conseil et devis gratuits",
        p: `Nous venons voir votre porte à ${c.name}, nous vous expliquons ses points faibles et vous recevez un devis clair avant toute commande. Aucun engagement, aucune pression commerciale.`,
      },
    ],
    prices: [
      ["Blindage simple de porte", "350 à 900 €"],
      ["Serrure multipoints", "280 à 650 €"],
      ["Cylindre de sécurité (3 clés)", "140 à 260 €"],
      ["Cornière anti-pince, poignée blindée", "sur devis"],
    ],
    faq: (c, x) => [
      {
        q: `Combien coûte un blindage de porte à ${c.name} ?`,
        a: "Entre 350 et 900 € pour un blindage simple selon la taille et le type de porte. Nous établissons un devis gratuit après avoir vu votre porte.",
      },
      {
        q: "Faut-il changer toute la porte ?",
        a: "Non, le blindage renforce votre porte existante. Le remplacement complet n'est utile que si la porte ou son cadre sont très abîmés.",
      },
      {
        q: `Venez-vous voir la porte à ${c.name} avant le devis ?`,
        a: `Oui, la visite et le devis sont gratuits. ${c.name} est à environ ${x.dist} km de notre base de Mont-Dol.`,
      },
    ],
  },
  {
    slug: "depannage-serrurerie",
    serviceId: "mise-en-securite",
    name: "Dépannage serrurerie urgence",
    fromPrice: "50",
    title: (c) => `Serrurier urgence ${c.name} (${c.postal}) — Dépannage 24h/24 7j/7`,
    description: (c, x) =>
      `Serrurier en urgence à ${c.name} 24h/24 : porte bloquée, clé cassée, serrure forcée, mise en sécurité après cambriolage. Arrivée en ${x.time}, tarifs annoncés avant.`,
    intro: (c, x) =>
      pick(
        [
          `Une urgence serrurerie à <strong>${c.name}</strong>, même à 3 h du matin ou un dimanche ? Nous décrochons, nous vous donnons le prix et nous arrivons en <strong>${x.time}</strong>.`,
          `Porte forcée, clé cassée dans la serrure, porte qui ne ferme plus : à <strong>${c.name}</strong>, notre <strong>serrurier d'urgence</strong> intervient 24h/24 et 7j/7 depuis Mont-Dol, à environ ${x.dist} km.`,
          `Vous ne pouvez pas laisser votre logement ouvert cette nuit à <strong>${c.name} (${c.postal})</strong> ? Nous sécurisons votre porte tout de suite, puis nous revenons faire la réparation définitive au moment qui vous arrange.`,
        ],
        c.slug,
      ),
    sections: (c) => [
      {
        h: `Nos dépannages d'urgence à ${c.name}`,
        p: `Ouverture de porte claquée ou fermée à clé, <strong>extraction de clé cassée</strong>, serrure bloquée ou grippée, porte qui ne ferme plus, <strong>mise en sécurité après cambriolage</strong> avec fermeture provisoire, remplacement de cylindre en urgence : nous avons le matériel nécessaire dans le camion.`,
      },
      {
        h: "Après un cambriolage",
        p: `Après le passage de la gendarmerie, nous sécurisons votre logement à ${c.name} : réparation ou remplacement de la serrure, fermeture provisoire si la porte est trop abîmée, puis remise en état définitive. Vous recevez une facture détaillée pour votre assurance.`,
      },
      {
        h: "Un vrai serrurier local, pas une plateforme",
        p: `Méfiez-vous des numéros nationaux qui sous-traitent à des inconnus et gonflent les prix. Chez Mon Serrurier Breton, vous parlez directement à l'artisan, le prix est annoncé avant de partir, et les majorations de nuit ou de week-end sont publiques.`,
      },
    ],
    prices: [
      ["Déplacement", "50 €"],
      ["Main-d'œuvre (par heure)", "65 à 85 €"],
      ["De 18h30 à 21h", "+30 %"],
      ["Après 21h, dimanches et fériés", "+50 %"],
    ],
    faq: (c, x) => [
      {
        q: `Êtes-vous vraiment disponible la nuit à ${c.name} ?`,
        a: "Oui, 24h/24 et 7j/7, jours fériés compris. Les majorations (+30 % de 18h30 à 21h, +50 % après 21h, le dimanche et les jours fériés) sont annoncées avant l'intervention.",
      },
      {
        q: `En combien de temps arrivez-vous à ${c.name} ?`,
        a: `Comptez ${x.time} depuis notre base de Mont-Dol, à environ ${x.dist} km.`,
      },
      {
        q: "Que faire après un cambriolage ?",
        a: "Appelez la gendarmerie pour porter plainte, ne touchez à rien, puis appelez-nous : nous sécurisons la porte le jour même et vous remettons une facture pour l'assurance.",
      },
    ],
  },
];
